import { createSlice } from '@reduxjs/toolkit';
import initialState from './episodeParticipantInitialState';
import { _setRefreshEpisodeParticipant } from './episodeParticipantActions'

export const episodeParticipantSlice = createSlice({
  name: 'episodeParticipant',
  initialState,
  reducers: {
    episodeParticipant: (state, action) => action.payload,
    setRefreshEpisodeParticipant: _setRefreshEpisodeParticipant
  },
});

export const { episodeParticipant, setRefreshEpisodeParticipant } = episodeParticipantSlice.actions;

export default episodeParticipantSlice.reducer;
